import { FormCommentReview } from '@/components/forms';
import { VerificationStateEnum } from '@/enums';
import { broadcastService } from '@/services';

type TParams = {
  onSubmit: (state: VerificationStateEnum, comment: string) => Promise<void>;
  state?: VerificationStateEnum;
  comment?: string;
};

const useFormCommentReview = () => {

  const comment = (params: TParams) =>
    broadcastService
      .modal
      .show({
        content: <FormCommentReview {...params} />,
        width: 'lg'
      });

  return ({
    comment
  });

};

export default useFormCommentReview;
